<template>
  <div class="rounded-md h-100p">
    <SimpleWarningDialog v-if="showDeleteWarn && checkedItems.length > 0" :title="$t('deleteWarn')" :text="stateValues.deleteWarningSubText" :secondaryBtn="true" @onPrimary="onClickCompleteProcess" @onSecondary="onClickCancelProcess" />
    <user-card v-if="stateValues.showUserCardDialog" pageType="ProcessList" :leadPartyId="stateValues.leadPartyId" :tckn="stateValues.tckn" :processId="stateValues.processId" :note="stateValues.note" @onClickOkCustomerCard="onClickOkCustomerCard" />
    <AddNoteDialog v-if="stateValues.showAddNoteDialog" :taskId="stateValues.taskId" @onClickCloseAddNoteDialog="onClickCloseAddNoteDialog" />
    <AssignToInitiatorDialog v-if="stateValues.showAssignToInitiatorDialog" :processId="stateValues.processId" :taskId="stateValues.taskId" @onCloseAssignToInitiatorDialog="onCloseAssignToInitiatorDialog" @onClickAssignToInitiatorDialog="onClickAssignToInitiatorDialog"></AssignToInitiatorDialog>
     <AssignProcessDialog v-if="stateValues.showAssignProcessDialog" :processId="stateValues.processId" @onCloseAssignProcessDialog="onCloseAssignProcessDialog"></AssignProcessDialog>
    <div class="title-wrapper">
      <h1 class="title">
        {{ $t("AuthAndVideoCallApprove") }}
      </h1>
    </div>

    <div class="content-container">
      <div class="content-wrapper">
        <AssignmentListTable ref="table" :showSelect="stateValues.inDeletingMode" @onClickCustomerCard="onClickCustomerCard" @onCheckedItems="setCheckedItems" @onClickAssignToInitiator="onClickAssignToInitiator" @onClickAssignProcess="onClickAssignProcess"/>
      </div>
    </div>
  </div>
</template>

<script>
import AuthAndVideoCall from "./mixin/AuthAndVideoCall";
import { AuthAndVideoCallApproveComponents } from "../../components";

export default {
  mixins: [AuthAndVideoCall],
  components: { ...AuthAndVideoCallApproveComponents }
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;

.h-100p {
  height: 100%;
}

.header-table-divider {
  margin-top: 2%;
}
.btn-new-identity {
  background-color: $primaryColor !important;
  color: white;
}
.v-btn {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/authandvideocall/AuthAndVideoCallApprove.vue